import { render } from "./DeviceScreenshot.vue?vue&type=template&id=4510014f&scoped=true"
import script from "./DeviceScreenshot.vue?vue&type=script&lang=js"
export * from "./DeviceScreenshot.vue?vue&type=script&lang=js"

import "./DeviceScreenshot.vue?vue&type=style&index=0&id=4510014f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4510014f"]])

export default __exports__